import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
//import { Phone } from "@mui/icons-material";

const defaultToolbarStyles = {
    iconButton: {
    },
};


class ResourcesAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            ResourcesId: null,
            Name: null,
            Description: null,
            Sales_Id: null,
            Tickets_Id: null,
            Operator_Id: null,
            Primary: null,
            FeePrice: null,
            Expenses: null,
            Unit: null,
            ExternalLink: null,
            Modifier: null,
            StartTime: null,
            EndTime: null,
            sales: (Object.keys(props.lookupLists.sales).map((d) => ({ value: d, label: props.lookupLists.sales[d] })) || []),
            tickets: (Object.keys(props.lookupLists.tickets).map((d) => ({ value: d, label: props.lookupLists.tickets[d] })) || []),
            operator: (Object.keys(props.lookupLists.operator).map((d) => ({ value: d, label: props.lookupLists.operator[d] })) || []),
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            openAddressSearch: false,
            ResourcesId: null,
            Name: null,
            Description: null,
            Sales_Id: null,
            Tickets_Id: null,
            Operator_Id: null,
            Primary: null,
            FeePrice: null,
            Expenses: null,
            Unit: null,
            ExternalLink: null,
            Modifier: null,
            StartTime: null,
            EndTime: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            ResourcesId: 1,
            Name: this.state.Name,
            Description: this.state.Description,
            Sales_Id: this.state.Sales_Id,
            Tickets_Id: this.state.Tickets_Id,
            Operator_Id: this.state.Operator_Id,
            Primary: this.state.Primary,
            FeePrice: this.state.FeePrice,
            Expenses: this.state.Expenses,
            Unit: this.state.Unit,
            ExternalLink: this.state.ExternalLink,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, sales, tickets, operator } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Resources.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Resources.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Resources.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Sales_Id')}
                                options={sales}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Resources.Columns[3]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Tickets_Id')}
                                options={tickets}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Resources.Columns[4]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Operator_Id')}
                                options={operator}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Resources.Columns[5]} />}
                            />
                        </Box>
                        <TextField
                            margin="dense"
                            label={dictionary.Resources.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.Primary}
                            onChange={this.handleChange('Primary')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Resources.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.FeePrice}
                            onChange={this.handleChange('FeePrice')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Resources.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.Expenses}
                            onChange={this.handleChange('Expenses')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Resources.Columns[9]}
                            type="text"
                            fullWidth
                            value={this.state.Unit}
                            onChange={this.handleChange('Unit')}
                        />

                        <TextField
                            margin="dense"
                            label={dictionary.Resources.Columns[10]}
                            type="text"
                            fullWidth
                            value={this.state.ExternalLink}
                            onChange={this.handleChange('ExternalLink')}
                        />

          
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "ResourcesAdd" })(ResourcesAdd);
